import { HostBinding, Input, SimpleChanges, OnInit, OnChanges, Directive } from '@angular/core';
import { NgControl, ValidationErrors } from '@angular/forms';
import { ValueAccessorBase } from '../../../../modules/tcm-form/common/value-accesor-base';
      
      @Directive()
export abstract class FormControlBase<T> extends ValueAccessorBase<T> implements OnInit, OnChanges {
      
          @HostBinding('class.waf-control') readonly useBaseCssClass: boolean = true;
      
          @Input() label: string;
      
          get disabled(): boolean {
              return this.ngModel && this.ngModel.disabled
          }
      
          @Input()
          set disabled(value: boolean) {
              this._disabled = value;
      
              if (value === true) {
                  this.disableControl();
              }
              else {
                  this.tryEnableControl();
              }
          }
      
          get isReadonlyValue(): boolean {
              return this._isReadonlyValueOverride || this._isReadonlyValue;
          }
      
          @Input()
          set isReadonlyValue(value: boolean) {
              this._isReadonlyValue = value;
      
              if (value === true) {
                  this.disableControl();
              }
              else {
                  this.tryEnableControl();
              }
          }
      
          @Input()
          autocomplete: boolean = false;
      
          @Input()
          hideValidationMessages: boolean;
      
          @Input()
          placeholder: string;
      
          @Input()
          tabindex: number = 0;
      
          readonly controlId;
      
          readonly inputName;
      
          get controlInstance(): FormControlBase<T> {
              return this;
          }
      
          get invalid(): boolean | null {
              return this.ngModel && this.ngModel.invalid;
          }
      
          get errors(): ValidationErrors | null {
              return this.ngModel ? this.ngModel.errors : {};
          }
      
          private _disabled: boolean = false;
          private _isReadonlyValue: boolean = false;
          private _isReadonlyValueOverride: boolean = false;
      
          constructor(public controlName: string = "", protected ngModel: NgControl) {
              super();
              if (this.ngModel) {
                  // Note: we provide the value accessor through here, instead of
                  // the `providers` to avoid running into a circular import.
                  this.ngModel.valueAccessor = this;
              }
          }
      
          ngOnInit() {
              var that: any = this;
      
              that.controlId = `${this.ngModel?.name}-${new Date().getTime()}`;
      
              that.inputName = `${this.controlName}-${this.controlId}`;
      
              this.onInit();
          }
      
        ngOnChanges(changes: SimpleChanges): void {
            if (this.ngModel && changes.isReadonlyValue) {
                if (this.isReadonlyValue === true) {                    
                    this.disabled = true;                
                }
                else if (!changes.isReadonlyValue.firstChange) {                    
                    this.forceEnableControl();              
                }
            }
        }  

        setReadonlyValueOverride(readonly: boolean) {
              this._isReadonlyValueOverride = readonly;
      
              if (readonly === true) {
                  this.disableControl();
              }
              else {
                  this.tryEnableControl();
              }
          }
      
          protected onInit() {
      
          }
      
          private disableControl() {
              this.ngModel.control?.disable();
          }
      
          private tryEnableControl() {
              if (this._disabled || this._isReadonlyValue || this._isReadonlyValueOverride || this.ngModel.control?.enabled)
                  return;
      
              this.ngModel.control?.enable();
          }

          private forceEnableControl() {
              if (this._isReadonlyValue || this._isReadonlyValueOverride) {                  
                  return;
              }                    
              this.ngModel.control?.enable();              
          }
      }